export enum identityDetailsTabs {
  ALERTS_TABLE = 'alertsTable',
}
